import CSS from "csstype"
import Spinner from "react-bootstrap/Spinner"

interface LoaderProps {
  style?: CSS.Properties
}

const Loader = ({ style }: LoaderProps) => {
  return <Spinner animation="border" style={style} />
}

export default Loader
